import React from 'react';

interface ShotClockViolationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onYes: () => void;
  onNo: () => void;
  submitting?: boolean;
}

const ShotClockViolationModal: React.FC<ShotClockViolationModalProps> = ({
  isOpen,
  onClose,
  onYes,
  onNo,
  submitting = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 m-4 max-w-md w-full">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-gray-800">Shot Clock Violation</h2>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={submitting}
          >
            ×
          </button>
        </div>

        <div className="mb-6">
          <p className="text-gray-700 text-center">Was this turnover due to a Shot Clock Violation?</p>
        </div>

        <div className="flex gap-4 justify-center">
          <button
            type="button"
            onClick={onYes}
            className="bg-[#d73027] text-white font-bold py-3 px-8 rounded-lg text-xl shadow-md hover:bg-[#b8261e] transition-all disabled:opacity-60 disabled:cursor-not-allowed"
            disabled={submitting}
          >
            {submitting ? 'Saving...' : 'YES'}
          </button>
          <button
            type="button"
            onClick={onNo}
            className="bg-[#294e87] text-white font-bold py-3 px-8 rounded-lg text-xl shadow-md hover:bg-[#1f3d6b] transition-all disabled:opacity-60 disabled:cursor-not-allowed"
            disabled={submitting}
          >
            {submitting ? 'Saving...' : 'NO'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShotClockViolationModal;
